import Bottle from "./Bottle";

export default Bottle;